import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Collapse } from "react-collapse";
import parse from "html-react-parser";
import ReactMarkdown from 'react-markdown';
import {LogEvent} from '@learningblocks/shared-components';

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";
import "./style.scss";

//Icons
import IconNotebook from "@learningblocks/protocol-constants/lib/Icons/notebook-solid";
import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";
//import IconMore from "@learningblocks/protocol-constants/lib/Icons/more-solid";
import IconEdit from "@learningblocks/protocol-constants/lib/Icons/pencil-solid";

export class ProtocolTask extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createNoteView: false,
      readNoteView: ((props.notes.length > 0)?true:false),
      normalView: true,
      menuOpen: false,
      note: "",
    };
  }

  handleClick = (e) => {
    const domNode = ReactDOM.findDOMNode(this.node);

    if (domNode) {
      if (domNode.contains(e.target)) {
        //Click is inside component
        return;
      }
      // Click is outside component -- close the menu
      this.setState({
        menuOpen: false,
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.page !== prevProps.page) {
      this.setState({
        createNoteView: false,
        readNoteView: false,
        normalView: true,
        menuOpen: false,
        note: "",
      });
    }

    if(prevProps.current !== this.props.current && this.props.current){
      this.task.parentNode.parentNode.scrollTop = this.task.offsetTop - 8;
    }
  }

  componentWillMount() {
    document.body.addEventListener("mousedown", this.handleClick, false);
  }

  componentWillUnmount() {
    document.body.removeEventListener("mousedown", this.handleClick, false);
  }

  showNotesClicked = () => {
    this.setState({
      readNoteView: !this.state.readNoteView,
      menuOpen: false,
      createNoteView: false,
    });
  };

  createNoteClicked = () => {
    this.setState({
      createNoteView: !this.state.createNoteView,
      menuOpen: false,
      readNoteView: false,
      note: "",
    });
  };

  toggleMenu = () => {
    this.setState({
      readNoteView: false,
      createNoteView: false,
      menuOpen: !this.state.menuOpen,
    });
  };

  handleFormChange = (e) => {
    this.setState({
      note: e.target.value,
    });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();

    this.setState({
      menuOpen: false,
      readNoteView: true,
      createNoteView: false,
      note: "",
    });

    this.props.saveTaskNote({
      note: this.state.note,
      page: this.props.page - 1,
      index: this.props.tIndex,
    });
  };

  renderTaskModalBtn = () => {
    let btn = "";

    if (this.props.modal === undefined) {
      return "";
    } else {

      if (this.props.modal.type === "SETUP_COMPLETE") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <button
            className={"task-button"}
            onClick={(e) => {
              this.props.setupComplete(true);
            }}
          >
            {this.props.modal.title}
          </button>
        );
      }

      if (this.props.modal.type === "LABEL_TUBES") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "LABEL_TUBES",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "EXPERIMENTAL_SETUP_POSTER") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "EXPERIMENTAL_SETUP_POSTER",
                  size: "cover",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "OVERNIGHT_WAIT") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "OVERNIGHT_WAIT",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "ROTATE_CUVETTE") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "ROTATE_CUVETTE",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "HOLD_CUVETTE") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "HOLD_CUVETTE",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "SPEC_INFO") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.spectrophotometerToggleInfoModal({
                  id: 1,
                  data: true
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "ABSORBANCE_TABLE") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "ABSORBANCE_TABLE",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
      //Choose type of button based on modal content
      if (this.props.modal.type === "PROTOCOL_TABLE") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "PROTOCOL_TABLE",
                  size: "aside",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
      if (this.props.modal.type === "DEPOSIT_SOLUTION") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "DEPOSIT_SOLUTION",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
      if (this.props.modal.type === "PREPARE_GELBOX") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "PREPARE_GELBOX",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
      if (this.props.modal.type === "LOAD_GELBOX_SOLUTION") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "LOAD_GELBOX_SOLUTION",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
      if (this.props.modal.type === "RUN_GELBOX") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "RUN_GELBOX",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
      if (this.props.modal.type === "VISUALISE_GEL") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "VISUALISE_GEL",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "PUT_ON_PPE") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "PUT_ON_PPE",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "THERMOCYCLER_POSTER") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "THERMOCYCLER_POSTER",
                  size: "cover",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "MASTERMIX_POSTER") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "MASTERMIX_POSTER",
                  size: "cover",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }

      if (this.props.modal.type === "THERMOCYCLER_RUN") {
        btn = (
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_popup viewed",
              event_schema: "popup",
              popup_type: this.props.modal.type
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              className={"task-button"}
              onClick={(e) => {
                this.props.setModal({
                  display: true,
                  type: "THERMOCYCLER_RUN",
                  size: "lg",
                  connect: -1,
                  data: this.props.modal,
                });
              }}
            >
              {this.props.modal.title}
            </button>
          </LogEvent>
        );
      }
    }

    return btn;
  };

  getAlphabetIndex = (index) => {
    if (index >= 26) {
      let upperIndex = Math.floor(index / 25);
      let delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  render() {
    return (
      <li
        className={
          "protocol-task" +
          (this.props.current ? " current-task" : "") +
          (this.props.complete ? " completed-task" : "")
        }
        tabIndex={0}
        ref={(task)=>{this.task = task}}
      >
        <div className="protocol-task-wrapper">
          <div className="index">
            <IconHexagon
              style={{
                color: this.props.current
                  ? "white"
                  : this.props.complete
                  ? colors.navy3
                  : colors.navy1,
                height: "29px",
              }}
            />
            <span
              style={{ color: this.props.current ? colors.navy1 : "white" }}
            >
              {this.props.complete
                ? " "
                : this.getAlphabetIndex(this.props.tIndex)}
            </span>
          </div>

          <span aria-label={this.props.aria} className="task-text">
            <ReactMarkdown components={{p: React.Fragment}}>{this.props.task}</ReactMarkdown>
          </span>
          <span> </span>
          <button
            className="anchor"
            onClick={this.showNotesClicked}
            style={{
              display:
                !this.state.readNoteView && this.props.notes.length > 0
                  ? "initial"
                  : "none",
              cursor: "pointer",
            }}
          >
            <IconNotebook
              style={{ color: colors.charcoal1, height: "15px", top: "2px" }}
            />
          </button>
          <div className="protocol-menu" ref={(node) => (this.node = node)}>
            <button
              className="toggle-menu anchor"
              onClick={this.createNoteClicked}
              aria-label="Notes. Select to view the options."
            >
              <IconEdit
                style={{
                  color: colors.navy1,
                  height: "16px",
                  top: "10px",
                  right: "10px",
                }}
              />
            </button>
            {/* <Collapse
                isOpened={this.state.menuOpen}
                aria-hidden={!this.state.menuOpen}
                theme={{ collapse: 'collapse', content: 'collapse-content' }}
                style={{ position: 'absolute' }}
                springConfig={{ stiffness: 500, damping: 30 }}>

                <button
                  className="anchor"
                  onClick={this.createNoteClicked}
                  tabIndex={(this.state.menuOpen) ? null : -1}>
                  Add Note
                </button>
              </Collapse> */}
          </div>

          <Collapse
            isOpened={this.state.readNoteView}
            aria-hidden={!this.state.readNoteView}
            theme={{ collapse: "collapse", content: "collapse-content" }}
            springConfig={{ stiffness: 500, damping: 30 }}
          >
            <div className="notes-content">
              <div className="notes">
                <p>Notes:</p>
                <div>
                  {this.props.notes.map((note, index) => (
                    <p key={index}>{parse(note)}</p>
                  ))}
                </div>
              </div>
              <button
                className="anchor"
                onClick={this.showNotesClicked}
                tabIndex={this.state.readNotesView ? null : -1}
              >
                Hide
              </button>
            </div>
          </Collapse>
          <Collapse
            isOpened={this.state.createNoteView}
            aria-hidden={!this.state.createNoteView}
            style={{ display: !this.state.createNoteView ? "none" : null }}
          >
            <form
              className="add-note-panel"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <p>Observations:</p>
              <textarea
                aria-label="Add observations text-entry field. Input text to add a note to this instruction."
                placeholder="Add observations"
                onChange={this.handleFormChange}
                value={this.state.note}
                tabIndex={this.state.createNoteView ? null : -1}
              />
              <div className="btns">
                <button
                  aria-label="Cancel button. Select to discard changes you’ve made to your notes."
                  className="anchor"
                  onClick={this.createNoteClicked}
                  tabIndex={this.state.createNoteView ? null : -1}
                >
                  Cancel
                </button>
                <LogEvent
                  logEventProps={{
                    event_type: "sim_protocol_step_note created",
                    event_schema: "note",
                    note: this.state.note,
                    part_number: this.props.pIndex,
                    step_number: this.getAlphabetIndex(this.props.tIndex) 
                  }}
                  actionProps={{ onClick: { action: 'click' } }}
                  elementType="button"
                >
                  <button
                    aria-label="Save note button. Select to save changes you’ve made to your notes."
                    type="submit"
                    tabIndex={this.state.createNoteView ? null : -1}
                    onClick={this.handleFormSubmit}
                  >
                    Save note
                  </button>
                </LogEvent>
              </div>
            </form>
          </Collapse>
        </div>
        {this.renderTaskModalBtn()}
      </li>
    );
  }
}

ProtocolTask.defaultProps = {
  notes: [],
};
